import React from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  TextField,
  Button,
  Paper
} from '@mui/material';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const color ={
   color: '#1f5d3b',
    fontSize: 24 
}

const data = [
  {
    icon: <LocationOnIcon sx={color} />, name: "Address", desc: "3898 شارع, Alyasmin, Riyadh 13325,Saudi Arabia"
  },
  {
    icon: <EmailIcon sx={color} />, name: "Email", desc: "info@alshaikh-law-firm.com"
  },
  {
    icon: <PhoneIcon sx={color} />, name: "Phone", desc: "+966112290004"
  }
]

const ContactSection: React.FC = () => {
  return (
    <Box id="contact" sx={{ py: { xs: 8, md: 12 }, background: '#ffffff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography variant="overline" sx={{ color: '#1f5d3b', fontWeight: 600, letterSpacing: 2, mb: 1, display: 'block' }}>
            GET IN TOUCH
          </Typography>
          <Typography variant="h3" sx={{ fontWeight: 700, color: '#111' }}>
            Contact Us
          </Typography>
        </Box>

        <Grid container spacing={8}>
          <Grid item xs={12} md={12}>
            <Box
              component="iframe"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d282.94199368129017!2d46.632900981501216!3d24.815062703510606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2ee5001af8dd7f%3A0x67d18cf115f26bdd!2z2LTYsdmD2Kkg2YfYtNin2YUg2KfZhNi02YrYriDZiNi02LHZg9in2KTZhyDZhNmE2YXYrdin2YXYp9ipINmI2KfZhNin2LPYqti02KfYsdin2Kog2KfZhNmC2KfZhtmI2YbZitip!5e0!3m2!1sen!2sin!4v1774263334332!5m2!1sen!2sin"
              sx={{
                width: '100%',
                height: 500,
                border: 0,
                borderRadius: '24px',
                mb: 6,
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
              }}
            />

            <Grid container spacing={4}>
              {
                data.map((item, index) => (
                  <Grid key={index} item xs={12} sm={6}>
                    <Paper elevation={0} sx={{ p: 3, display: 'flex', alignItems: 'flex-start', backgroundColor: '#f9fafb', borderRadius: '16px', border: '1px solid #eee' }}>
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: '12px',
                          backgroundColor: 'rgba(31, 93, 59, 0.1)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mr: 2,
                          flexShrink: 0
                        }}
                      >
                        {item?.icon}
                      </Box>
                      <Box>
                        <Typography variant="h6" fontWeight={700} mb={0.5}>{item?.name}</Typography>
                        <Typography variant="body2" color="text.secondary" lineHeight={1.6}>
                          {
                            item?.desc
                          }
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))
              }


           
            </Grid>
          </Grid>

          {/* <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 4, md: 6 },
                borderRadius: '24px',
                border: '1px solid rgba(0,0,0,0.05)',
                boxShadow: '0 20px 60px rgba(0,0,0,0.05)'
              }}
            >
              <Typography variant="h4" fontWeight={700} mb={4} color="#111">
                Send a Message
              </Typography>
              
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Full Name"
                sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#f9fafb' } }}
              />

              <TextField
                fullWidth
                variant="outlined"
                placeholder="Email Address"
                sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#f9fafb' } }}
              />

              <TextField
                fullWidth
                variant="outlined"
                placeholder="Phone Number"
                sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#f9fafb' } }}
              />

              <TextField
                fullWidth
                multiline
                rows={5}
                variant="outlined"
                placeholder="How can we help you?"
                sx={{ mb: 4, '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#f9fafb' } }}
              />

              <Button
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: '#1f5d3b',
                  color: '#fff',
                  fontWeight: 600,
                  py: 1.8,
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  borderRadius: '12px',
                  boxShadow: '0 8px 16px rgba(31, 93, 59, 0.3)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#16442b',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 20px rgba(31, 93, 59, 0.4)'
                  }
                }}
              >
                Send Message
              </Button>
            </Paper>
          </Grid> */}
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactSection;

